import { categoryLabel } from "@/lib/categories";

/** Filtren i en bevakning. Ingen AI – bara vanliga databasvillkor. */
export type SavedQuery = {
  q?: string | null;
  categories?: string[] | null;
  location?: string | null;
  minPrice?: number | null;
  maxPrice?: number | null;
  saleKind?: "fixed" | "auction" | null;
  sellerType?: "private" | "business" | null;
};

/** Läsbar sammanfattning av filtren, används i listan och i mejlen. */
export function describeQuery(q: SavedQuery): string {
  const parts: string[] = [];
  if (q.q) parts.push(`"${q.q}"`);
  if (q.categories?.length) parts.push(q.categories.map((c) => categoryLabel(c)).join(", "));
  if (q.location) parts.push(q.location);
  if (q.minPrice && q.maxPrice) parts.push(`${q.minPrice}–${q.maxPrice} kr`);
  else if (q.maxPrice) parts.push(`upp till ${q.maxPrice} kr`);
  else if (q.minPrice) parts.push(`från ${q.minPrice} kr`);
  if (q.saleKind === "auction") parts.push("auktioner");
  if (q.saleKind === "fixed") parts.push("fast pris");
  if (q.sellerType === "business") parts.push("företag");
  if (q.sellerType === "private") parts.push("privatpersoner");
  return parts.join(" · ") || "Alla annonser";
}
